import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge, Button, Card, Dropdown, Grid, Tabs, ButtonGroup, Panel, Confirm, WebRequest, InfoTooltip,
} from 'framework-ui-components';
import { IFrame } from 'framework-plugins';
import PlusIcon from 'framework-ui-components/Components/Icons/PlusIcon';
import MoreIcon from 'framework-ui-components/Components/Icons/MoreIcon';
import PrinterIcon from 'framework-ui-components/Components/Icons/PrinterIcon';
import SimpleQuestionMarkIcon from 'framework-ui-components/Components/Icons/SimpleQuestionMarkIcon';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

import { InputRicerca, PageWrapper } from 'dashboard';
import {
  annullaElimina, creaSetteTrentaOrdinaria, creaSetteTrentaIntegrativa, creaStampa, creaStampaOld,
  statiSetteTrenta,
  isAbilitatoImportXmlAnnoCorrente, impostazioniServizioSetteTrenta,
  cercaDichiarazioni, soscaf,
} from 'apis/setteTrentaApi';
import TipoDichiarazione from 'enums/TipoDichiarazione';
import Servizi from 'enums/Servizi';
import { Scadenze730, StatoDichiarazione } from 'enums';
import { startLoadingApplication, stopLoadingApplication } from 'actions/applicationActions';

import { bindActionCreators } from 'redux/es';
import { getValue as getStorageValue, removeValue as removeStorageValue, setValue as setStorageValue } from '../../utils/globalStorage';
import ImportIcon from '../../components/Icons/ImportIcon';
import { setAnnoSelezionato } from '../../actions/dichiarativiActions';
import EventoServer from '../../libs/EventoServer';
import RigaDichiarazione from './RigaDichiarazione';
import ModaleCreazione from './ModaleCreazione';
import ModaleStampa from './ModaleStampa';
import ModaleStampa2 from './ModaleStampa2';
import ModaleImportazione from './ModaleImportazione';
import ModaleImportazioneRedditiPF from './ModaleImportazioneRedditiPF';
import ModaleUploadFile from './ModaleUploadFile';
import ModaleScadenze from './ModaleScadenze';
import ModaleUltimaScadenza from './ModaleScadenze/ModaleUltimaScadenza';
import ModaleTermineUltimo from './ModaleScadenze/ModaleTermineUltimo';
import ModaleImportazionePdf from './ModaleImportazionePdf';
import ModaleNotificaScarto from './ModaleNotificaScarto';
import ElasticTable from './ElasticTable';
import azioniMassive from './gestoreAzioniMassive';
import checkServizio from '../../helpers/checkServizio';
import AuditIcon from '../../components/Icons/AuditIcon';
import ExcelIcon from '../../components/Icons/ExcelIcon';
import NotificaPotenzialiIsee from '../../components/PotenzialiIsee/NotificaPotenzialiIsee';

const INITIAL_TAB_INDEX = 0;

const DOPO_5_MAGGIO = Date.now() > new Date('2020-05-05').getTime();

const MOSTRA_NOTIFICA_ULTIMA_SCADENZA_KEY = 'MOSTRA_NOTIFICA_ULTIMA_SCADENZA_KEY';
const MOSTRA_NOTIFICA_TERMINE_ULTIMO_KEY = 'MOSTRA_NOTIFICA_TERMINE_ULTIMO_KEY';

function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this; const
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

class Dichiarazioni extends Component {
  state = {
    datiInizialiModale: null,
    dichiarazioni: [],
    isLoadingModaleCreazione: false,
    isLoadingModaleStampa: false,
    isLoadingModaleImportazione: false,
    isLoadingModaleUpload: false,
    searchTerm: '',
    selezionati: [],
    tabSelezionato: INITIAL_TAB_INDEX,
    messaggioErroreCreazione: null,
    messaggioErroreStampa: null,
    messaggioErroreImportazione: null,
    mostraModaleCreazione: false,
    mostraModaleStampa: false,
    mostraModaleStampa2: false,
    mostraModaleImportazione: false,
    mostraModaleImportazioneRedditiPF: false,
    annoImportazione: 0,
    mostraModaleUpload: false,
    mostraModaleImportazionePdf: false,
    mostraModaleNotificaScarto: false,
    mostraModaleScadenze: false,
    mostraUltimaScadenza: getStorageValue(MOSTRA_NOTIFICA_ULTIMA_SCADENZA_KEY),
    mostraTermineUltimo: getStorageValue(MOSTRA_NOTIFICA_TERMINE_ULTIMO_KEY),
    nonVisualizzarePiuNotificaUltimaScadenza: false,
    nonVisualizzarePiuNotificaTermineUltimo: false,
    tipoDichiarazioneCreazione: ModaleCreazione.TipoDichiarazione.NON_SELEZIONATO,
    tipoDichiarazioneImportazione: ModaleImportazione.TipoImportazione.NON_SELEZIONATO,
    stampaInCorso: false,
    nTotali: 0,
    nLavorazione: 0,
    nScartate: 0,
    nDaInviare: 0,
    nTrasmesse: 0,
    nRicevuteAdE: 0,
    urlFileUpload: '',
    typeFileUpload: [],
    puoImportareXMLAnnoCorrente: false,
    selezionaTutte: false,
    elementi: [],
    totaleElementi: 0,
    impostazioni: {},
    delegatoCentrale: null,
  };

  componentDidMount() {
    if (this.props.annoSelezionato === 2021) {
      window.location.hash = '/NewSetteTrenta/lista-dichiarazioni';
      return;
    }

    const { ufficioSelezionato, annoSelezionato } = this.props;
    EventoServer.subscribe('CreazioneIntegrativaFallita', this.notificaCreaIntegrativaFallita);
    EventoServer.subscribe('ImportazioneDichiarazioneDaXmlTerminata', this.notificaImportazioneDichiarazioneDaXmlTerminata);
    EventoServer.subscribe('ImportazioneDichiarazioneDaRedditiPFTerminata', this.notificaImportazioneDichiarazioneDaRedditiPFTerminata);
    EventoServer.subscribe('CreaSetteTrentaDaPassaggioNuovoAnnoTerminata', this.notificaCreaSetteTrentaDaPassaggioNuovoAnnoTerminata);
    EventoServer.subscribe('DichiarazioneDatiAggiuntiviModificati', this.aggiornaDatiAggiuntivi);
    EventoServer.subscribe('DichiarazioneEliminata', this.gestisciEliminata);
    EventoServer.subscribe('DichiarazioneIntegrativaCreato', this.notificaCreazioneIntegrativa);
    EventoServer.subscribe('DichiarazioneStatoModificato', this.ricaricaTabella);
    EventoServer.subscribe('AnagraficaDichiarazioneModificata', this.ricaricaTabella);
    EventoServer.subscribe('SegnalibroModificato', this.ricaricaTabella);
    EventoServer.subscribe('StampaDichiarazioneCompletata', this.stampaTerminata);
    EventoServer.subscribe('CreaSetteTrentaDaPassaggioNuovoAnnoFallito', this.notificaCreaSetteTrentaDaPassaggioNuovoAnnoFallito);
    if (annoSelezionato !== 0) {
      this.caricaStati(ufficioSelezionato.CodiceUfficio, this.state.searchTerm, annoSelezionato, false);
      this.isAbilitatoImportXmlAnnoCorrente(ufficioSelezionato.CodiceUfficio, annoSelezionato);
      this.impostazioniServizioSetteTrenta(annoSelezionato);
      soscaf(ufficioSelezionato.CodiceUfficio, annoSelezionato)
        .then(({ Titolo, CodiceFiscaleIncaricato }) => this.setState({
          delegatoCentrale: Titolo === '003' && CodiceFiscaleIncaricato === 'DGNGLG63M09G888C',
        }));
      cercaDichiarazioni({
        searchType: ElasticTable.StatiRicercaSetteTrenta.TRASMESSE,
        ufficio: ufficioSelezionato.CodiceUfficio,
        anno: annoSelezionato,
        searchTerm: '',
        $filter: `Stato eq ${StatoDichiarazione.TrasmessaAutomaticamente}`,
        $skip: 0,
        $top: 100,
      }).then((dichiarazioniRicevuteAdE) => this.setState({ nRicevuteAdE: dichiarazioniRicevuteAdE.Count }));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.annoSelezionato === 2021) {
      window.location.hash = '/NewSetteTrenta/lista-dichiarazioni';
      return;
    }

    const { ufficioSelezionato, annoSelezionato } = this.props;
    if (annoSelezionato != 0 && ufficioSelezionato.CodiceUfficio != nextProps.ufficioSelezionato.CodiceUfficio) {
      this.inputRicerca && this.inputRicerca.svuotaRicerca(false);
      this.setState({ searchTerm: '' });
      this.caricaStati(nextProps.ufficioSelezionato.CodiceUfficio, '', nextProps.annoSelezionato, false);
      this.isAbilitatoImportXmlAnnoCorrente(nextProps.ufficioSelezionato.CodiceUfficio, nextProps.annoSelezionato);
    }
    if (annoSelezionato != nextProps.annoSelezionato) {
      this.inputRicerca && this.inputRicerca.svuotaRicerca(false);
      this.setState({ searchTerm: '' });
      this.caricaStati(nextProps.ufficioSelezionato.CodiceUfficio, '', nextProps.annoSelezionato, false);
      this.isAbilitatoImportXmlAnnoCorrente(nextProps.ufficioSelezionato.CodiceUfficio, nextProps.annoSelezionato);
      this.impostazioniServizioSetteTrenta(nextProps.annoSelezionato);
    }

    if (annoSelezionato !== nextProps.annoSelezionato || ufficioSelezionato.CodiceUfficio !== nextProps.ufficioSelezionato.CodiceUfficio) {
      soscaf(nextProps.ufficioSelezionato.CodiceUfficio, nextProps.annoSelezionato)
        .then(({ Titolo, CodiceFiscaleIncaricato }) => this.setState({
          delegatoCentrale: Titolo === '003' && CodiceFiscaleIncaricato === 'DGNGLG63M09G888C',
        }));
      cercaDichiarazioni({
        searchType: ElasticTable.StatiRicercaSetteTrenta.TRASMESSE,
        ufficio: ufficioSelezionato.CodiceUfficio,
        anno: annoSelezionato,
        searchTerm: '',
        $filter: `Stato eq ${StatoDichiarazione.TrasmessaAutomaticamente}`,
        $skip: 0,
        $top: 100,
      }).then((dichiarazioniRicevuteAdE) => this.setState({ nRicevuteAdE: dichiarazioniRicevuteAdE.Count }));
    }
  }

  componentWillUnmount() {
    EventoServer.unsubscribe('DichiarazioneIntegrativaCreato', this.notificaCreazioneIntegrativa);
    EventoServer.unsubscribe('CreazioneIntegrativaFallita', this.notificaCreaIntegrativaFallita);
    EventoServer.unsubscribe('ImportazioneDichiarazioneDaXmlTerminata', this.notificaImportazioneDichiarazioneDaXmlTerminata);
    EventoServer.unsubscribe('ImportazioneDichiarazioneDaRedditiPFTerminata', this.notificaImportazioneDichiarazioneDaRedditiPFTerminata);
    EventoServer.unsubscribe('CreaSetteTrentaDaPassaggioNuovoAnnoTerminata', this.notificaCreaSetteTrentaDaPassaggioNuovoAnnoTerminata);
    EventoServer.unsubscribe('DichiarazioneDatiAggiuntiviModificati', this.aggiornaDatiAggiuntivi);
    EventoServer.unsubscribe('DichiarazioneEliminata', this.gestisciEliminata);
    EventoServer.unsubscribe('DichiarazioneStatoModificato', this.ricaricaTabella);
    EventoServer.unsubscribe('SegnalibroModificato', this.ricaricaTabella);
    EventoServer.unsubscribe('AnagraficaDichiarazioneModificata', this.ricaricaTabella);
    EventoServer.unsubscribe('StampaDichiarazioneCompletata', this.stampaTerminata);
    EventoServer.unsubscribe('CreaSetteTrentaDaPassaggioNuovoAnnoFallito', this.notificaCreaSetteTrentaDaPassaggioNuovoAnnoFallito);
  }

  onNonVisualizzarePiuNotificaUltimaScadenza = ({ currentTarget }) => {
    this.setState({ nonVisualizzarePiuNotificaUltimaScadenza: currentTarget.checked });

    if (currentTarget.checked) {
      setStorageValue(MOSTRA_NOTIFICA_ULTIMA_SCADENZA_KEY, MOSTRA_NOTIFICA_ULTIMA_SCADENZA_KEY);
    } else {
      removeStorageValue(MOSTRA_NOTIFICA_ULTIMA_SCADENZA_KEY);
    }
  };

  onNonVisualizzarePiuNotificaTermineUltimo = ({ currentTarget }) => {
    this.setState({ nonVisualizzarePiuNotificaTermineUltimo: currentTarget.checked });

    if (currentTarget.checked) {
      setStorageValue(MOSTRA_NOTIFICA_TERMINE_ULTIMO_KEY, MOSTRA_NOTIFICA_TERMINE_ULTIMO_KEY);
    } else {
      removeStorageValue(MOSTRA_NOTIFICA_TERMINE_ULTIMO_KEY);
    }
  };

  notificaDichiarazioniScartate() {
    const { ufficioSelezionato, annoSelezionato } = this.props;
    const key = `DATA-NOTIFICA-730-SCARTATI-PM-${ufficioSelezionato.CodiceUfficio}`;
    const dataUltimaNotifica = parseInt(getStorageValue(key) || '0', 10);
    const dataAttuale = Date.now();

    if (dataAttuale - dataUltimaNotifica > 86400000) {
      cercaDichiarazioni({
        searchType: ElasticTable.StatiRicercaSetteTrenta.SCARTATE,
        ufficio: ufficioSelezionato.CodiceUfficio,
        anno: annoSelezionato,
        searchTerm: '',
        $skip: 0,
        $top: 100,
      }).then((dichiarazioniScartate) => {
        if (dichiarazioniScartate.Count > 0) {
          setStorageValue(key, dataAttuale.toString());
          this.setState({ mostraModaleNotificaScarto: true, dichiarazioniScartate });
        }
      });
    }
  }

  isAbilitatoImportXmlAnnoCorrente = (studio, anno) => {
    isAbilitatoImportXmlAnnoCorrente(studio, anno)
      .then((res) => {
        this.setState({
          puoImportareXMLAnnoCorrente: res,
        });
      });
  };

  impostazioniServizioSetteTrenta = (anno) => {
    const { impostazioni } = this.state;

    if (anno == 2020 && !impostazioni[anno]) {
      impostazioniServizioSetteTrenta(anno)
        .then((res) => {
          this.setState({
            impostazioni: { ...impostazioni, [anno]: res },
          });
        });
    }
  };

  caricaStati = (studio, searchTerm, anno, ricerca) => {
    statiSetteTrenta(studio, searchTerm, anno)
      .then((x) => {
        const dati = {};
        for (const a in x) {
          dati[x[a].Stato] = x[a].Totale;
        }
        const totali = dati[ElasticTable.StatiRicercaSetteTrenta.TUTTE] || 0;
        const inLavorazione = dati[ElasticTable.StatiRicercaSetteTrenta.IN_LAVORAZIONE] || 0;
        const scartate = dati[ElasticTable.StatiRicercaSetteTrenta.SCARTATE] || 0;
        const daInviare = dati[ElasticTable.StatiRicercaSetteTrenta.DA_INVIARE] || 0;
        const trasmesse = dati[ElasticTable.StatiRicercaSetteTrenta.TRASMESSE] || 0;

        //  Auto seleziono il tab visualizzato in base al ritorno della ricerca
        const tabSelezionato = () => {
          if (searchTerm && ricerca) {
            if (scartate != 0) return 4;
            if (inLavorazione != 0) return 1;
            if (daInviare != 0) return 2;
            if (trasmesse != 0) return 3;
          }

          if (ricerca) {
            return 0;
          }

          return null;
        };

        const stat = {
          nTotali: totali,
          nLavorazione: inLavorazione,
          nScartate: scartate,
          nDaInviare: daInviare,
          nTrasmesse: trasmesse,
        };

        if (tabSelezionato() != null) {
          stat.tabSelezionato = tabSelezionato();
        }

        this.setState(stat);

        if (scartate > 0 && anno === new Date().getFullYear()) {
          this.notificaDichiarazioniScartate();
        }
      });
  };

  gestisciEliminata = (data) => {
    const { anniRegistrati, annoSelezionato } = this.props;

    this.ricaricaTabella();
    if (data.AzioneAnnullata === true) {
      this.chiudiModaleCreazione();
      const url = anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].Url730;
      window.location.href = `${url}#/Frontespizio/${data.IdDichiarazione.split('/')[1]}`;
    }
  };

  ricaricaTabella = debounce(() => {
    this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, this.state.searchTerm, this.props.annoSelezionato, false);
    this.tabellaDichiarazioni && this.tabellaDichiarazioni.loadPage();
  }, 1000, false);

  aggiornaDatiAggiuntivi = (evt) => {
    const items = this.tabellaDichiarazioni.getItems();
    const eq = items.filter((x) => x.IdDichiarazione == evt.IdDichiarazione);
    if (eq.length > 0) {
      eq[0].DatiAddizionali = evt.DatiAddizionali;
    }
  };

  // stampa per anni antecedenti al 2020
  stampaDichiarazioniOld = (data) => {
    const {
      SalvaPreferenze,
      IsStampaUfficiale,

      StampaDichiarazione,
      AutocertificazioneGenerica,
      FascicoloContribuente,

      AutocertificazioneFamiglieNumerose,
      DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
      InformativaPrivacy,

      AutocertificazioneFamiliari,
      StampaF24,
      Scelta582x1000,

      AutocertificazioneC4,
      RichiestaAccredito,
      DocumentiDaConsegnare,

      AutocertificazioneOneri,
      PromemoriaConguagli,
      DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta

      AutocertificazioneF6,
      CalcoloBonusIRPEF,

      Fatture,
      LetteraNovita,
      Barra2Provvisorio,

      RistampaLeStampate,
      NrCopie,
      FronteRetro,
      ModelliCompilati,
      GuidaLettura,
      ImpostazioneStampa,
      MaxPaginePdf,
      ArchiviaInZip,
    } = data;

    const { selezionati, selezionaTutte, totaleElementi } = this.state;
    const { ufficioSelezionato, annoSelezionato } = this.props;
    const dichiarazioniIds = [];

    selezionati.forEach((element) => {
      if (element.IdDichiarazione != null) {
        dichiarazioniIds.push(element.IdDichiarazione);
      }
    });

    if (dichiarazioniIds.length == 0) {
      SnackbarManager.notifyError('Nessuna dichiarazione stampabile selezionata');
    } else {
      this.setState({ isLoadingModaleStampa: true }, () => {
        creaStampaOld(
          this.tabellaDichiarazioni.urlCorrente().replace('/SetteTrenta/CercaSetteTrenta?', ''),
          !selezionaTutte ? dichiarazioniIds : null,
          IsStampaUfficiale,
          StampaDichiarazione,
          AutocertificazioneGenerica,
          FascicoloContribuente,
          AutocertificazioneFamiglieNumerose,
          DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
          InformativaPrivacy,
          AutocertificazioneFamiliari,
          StampaF24,
          Scelta582x1000,
          AutocertificazioneC4,
          RichiestaAccredito,
          DocumentiDaConsegnare,
          AutocertificazioneOneri,
          PromemoriaConguagli,
          DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta
          AutocertificazioneF6,
          CalcoloBonusIRPEF,
          Fatture,
          LetteraNovita,
          Barra2Provvisorio,
          RistampaLeStampate,
          FronteRetro,
          ModelliCompilati,
          GuidaLettura,
          NrCopie,
          SalvaPreferenze,
          ufficioSelezionato.CodiceUfficio,
          annoSelezionato,
          ArchiviaInZip,
        ).then((resp) => {
          if (!resp.Success) {
            this.setState({ messaggioErroreStampa: resp.DetectedProblems, isLoadingModaleStampa: false });
          } else {
            SnackbarManager.startDeterminateAsyncTask(
              resp.CorrelationId,
              'Stampa PDF in corso',
              selezionaTutte ? Math.min(totaleElementi, window.config.maxDichiarazioniStampabili) : dichiarazioniIds.length,
            );
            if (annoSelezionato > 2019
              && (NrCopie > 10
                || dichiarazioniIds.length > 10
                || (selezionaTutte && Math.min(totaleElementi, window.config.maxDichiarazioniStampabili) > 10))) {
              Confirm('Informazione', <div>Il processo di stampa potrebbe durare più tempo del previsto. Potrai consultare lo stato di avanzamento accedendo all'apposita pagina <a href="#/elaborazionimassive">Monitora stampe</a>.</div>, 'info', 'HO CAPITO', 'modal-alert').then(() => { });
            }
            this.setState({ stampaInCorso: true });
            this.chiudiModaleStampa();
            this.annullaSelezione();
          }
        });
      });
    }
  };

  // stampa per anni successivi al 2019
  stampaDichiarazioni = (data, avvisaOperazioneLunga) => {
    const {
      SalvaPreferenze,
      IsStampaUfficiale,

      StampaDichiarazione,
      AutocertificazioneGenerica,
      FascicoloContribuente,

      DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
      InformativaPrivacy,

      AutocertificazioneFamiliari,
      StampaF24,
      Scelta582x1000,

      AutocertificazioneC4,
      AutocertificazioneCasiParticolariQuadroC,
      RichiestaAccredito,
      DocumentiDaConsegnare,

      AutocertificazioneOneri,
      PromemoriaConguagli,
      DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta

      AutocertificazioneF6,
      CalcoloBonusIRPEF,

      Fatture,
      LetteraNovita,
      Barra2Provvisorio,

      RistampaLeStampate,
      NrCopie,
      FronteRetro,
      ModelliCompilati,
      GuidaLettura,
      Ricevuta730AdE,
      ArchiviaInZip,
    } = data;

    const { selezionati, selezionaTutte, totaleElementi } = this.state;
    const { ufficioSelezionato, annoSelezionato } = this.props;
    const dichiarazioniIds = [];

    selezionati.forEach((element) => {
      dichiarazioniIds.push({
        id: element.IdDichiarazione,
        cf: element.CodiceFiscale,
        cognome: element.Cognome,
        nome: element.Nome,
        origine: element.DatiAddizionali.Origine,
      });
    });

    if (dichiarazioniIds.length == 0) {
      SnackbarManager.notifyError('Nessuna dichiarazione stampabile selezionata');
    } else {
      this.setState({ isLoadingModaleStampa: true }, () => {
        creaStampa(
          this.tabellaDichiarazioni.urlCorrente().replace('/SetteTrenta/CercaSetteTrenta?', ''),
          !selezionaTutte ? dichiarazioniIds : null,
          IsStampaUfficiale,
          StampaDichiarazione,
          AutocertificazioneGenerica,
          FascicoloContribuente,
          DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
          InformativaPrivacy,
          AutocertificazioneFamiliari,
          StampaF24,
          Scelta582x1000,
          AutocertificazioneC4,
          AutocertificazioneCasiParticolariQuadroC,
          RichiestaAccredito,
          DocumentiDaConsegnare,
          AutocertificazioneOneri,
          PromemoriaConguagli,
          DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta
          AutocertificazioneF6,
          CalcoloBonusIRPEF,
          Fatture,
          LetteraNovita,
          Barra2Provvisorio,
          RistampaLeStampate,
          FronteRetro,
          ModelliCompilati,
          GuidaLettura,
          Ricevuta730AdE,
          NrCopie,
          SalvaPreferenze,
          ufficioSelezionato.CodiceUfficio,
          annoSelezionato,
          ArchiviaInZip,
        ).then((resp) => {
          if (!resp.Success) {
            this.setState({ messaggioErroreStampa: resp.DetectedProblems[0], isLoadingModaleStampa: false });
          } else {
            SnackbarManager.startDeterminateAsyncTask(
              resp.CorrelationId,
              'Stampa PDF in corso',
              selezionaTutte ? totaleElementi : dichiarazioniIds.length,
            );
            // if (avvisaOperazioneLunga) {
            //  Confirm('Informazione', <div>Il processo di stampa potrebbe durare più tempo del previsto. Potrai consultare lo stato di avanzamento accedendo all&apos;apposita pagina <a href="#/elaborazionimassive">Monitora stampe</a>.</div>, 'info', 'HO CAPITO', 'modal-alert').then(() => { });
            // }
            this.setState({ stampaInCorso: true });
            this.chiudiModaleStampa();
            this.annullaSelezione();

            // se dopo tot è ancora stampa in corso avvisa...
            setTimeout((correlationId) => {
              if (this.state.stampaInCorso) {
                this.setState({ stampaInCorso: false, selezionati: [], selezionaTutte: false });

                Confirm(
                  'Informazione',
                  <div>Il processo di stampa in corso potrebbe richiedere alcuni minuti. Puoi consultare lo stato di avanzamento dalla sezione <strong><a href="#/elaborazionimassive">Monitora Stampe</a></strong>.<br /><br />
                    I file di stampa rimarranno a disposizione per 7 giorni.
                  </div>,
                  'info',
                  'HO CAPITO',
                  'modal-alert',
                ).then(
                  () => { },
                );
                SnackbarManager.notifyAsyncTaskError(
                  correlationId,
                  'Stampa in corso..',
                  'Per consultare lo stato di avanzamento della stampa accedere alla sezione \'Monitora Stampe\'',
                );
                SnackbarManager.completeAsyncTask(
                  correlationId,
                  '',
                  'Monitora Stampe',
                  () => {
                    this.apriMonitorStampe();
                  },
                );
              }
            }, 40000, resp.CorrelationId);
          }
        });
      });
    }
  };

  creaNuovaDichiarazione = (data) => {
    const { anniRegistrati, annoSelezionato, ufficioSelezionato } = this.props;

    this.setState({ isLoadingModaleCreazione: true }, () => {
      if (data.TipoDichiarazione == TipoDichiarazione.Ordinaria) {
        creaSetteTrentaOrdinaria(ufficioSelezionato.CodiceUfficio, data.CodiceFiscale.trim().toUpperCase(), data.Nome.trim().toUpperCase(), data.Cognome.trim().toUpperCase(), data.TipoDichiarazione, annoSelezionato)
          .then((res) => {
            if (res.Success) {
              const url = anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].Url730;
              window.location.href = `${url}#/Frontespizio/${res.IdDichiarazione.split('/')[1]}`;
              this.chiudiModaleCreazione();
            } else {
              this.setState({ messaggioErroreCreazione: res.DetectedProblems });
            }

            this.setState({ isLoadingModaleCreazione: false });
          });
      } else {
        const cmd = {
          Studio: ufficioSelezionato.CodiceUfficio,
          CodiceFiscale: data.CodiceFiscale.toUpperCase(),
          Nome: data.Nome.toUpperCase(),
          Cognome: data.Cognome.toUpperCase(),
          TipoDichiarazione: data.TipoDichiarazione,
          Protocollo: data.Protocollo,
          Anno: annoSelezionato,
        };
        if (data.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2) {
          cmd.SenzaSostituto = data.SceltaSostituto == 0;
          cmd.IBAN = data.SceltaSostituto == 0 ? data.CodiceIban : null;
          cmd.IdSostitutoImposta = data.Sostituto ? data.Sostituto.IdSostituto : null;
          cmd.DataPrimaRata = data.DataPrimaRata;
        }
        creaSetteTrentaIntegrativa(cmd)
          .then((resp) => {
            if (!resp.Success) {
              this.setState({ messaggioErroreCreazione: resp.DetectedProblems });
            } else {
              this.chiudiModaleCreazione();
            }
            this.setState({ isLoadingModaleCreazione: false });
          });
      }
    });
  };

  ripristinaEliminata = (data) => {
    this.setState({ isLoadingModaleCreazione: true }, () => {
      annullaElimina(data.dichiarazioneEsistente.IdDichiarazione, this.props.annoSelezionato)
        .then((res) => {
          if (!res.Success) {
            this.setState({ messaggioErroreCreazione: res.DetectedProblems });
          }

          this.setState({ isLoadingModaleCreazione: false });
        });
    });
  };

  notificaCreaIntegrativaFallita = (evt) => {
    this.setState({ messaggioErroreCreazione: "Errore durante la creazione dell'integrativa." });
  };

  notificaImportazioneDichiarazioneDaXmlTerminata = (evt) => {
    this.setState({ isLoadingModaleImportazione: false });
    this.chiudiModaleImportazione();
    this.ricaricaTabella();
  };

  notificaImportazioneDichiarazioneDaRedditiPFTerminata = (evt) => {
    this.setState({ isLoadingModaleImportazione: false });
    this.chiudiModaleImportazioneRedditiPF();
    this.ricaricaTabella();
  };

  notificaCreaSetteTrentaDaPassaggioNuovoAnnoTerminata = (evt) => {
    const { anniRegistrati, annoSelezionato, stopLoadingApplication } = this.props;

    stopLoadingApplication();
    const url = anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].Url730;
    window.location.href = `${url}#/Frontespizio/${evt.IdDichiarazione.split('/')[1]}`;
  };

  notificaCreaSetteTrentaDaPassaggioNuovoAnnoFallito = (evt) => {
    SnackbarManager.notifyError('Errore nel passaggio al nuovo anno della dichiarazione');
  };

  notificaCreazioneIntegrativa = (evt) => {
    const { anniRegistrati, annoSelezionato } = this.props;

    if (evt.IdDichiarazioneInteressata) {
      this.chiudiModaleCreazione();
      const url = anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].Url730;
      window.location.href = `${url}#/Frontespizio/${evt.IdDichiarazioneInteressata.split('/')[1]}`;
    }
  };

  onClickCerca = (searchTerm) => {
    this.setState({ searchTerm: searchTerm.trim() }, () => {
      // this.tabellaDichiarazioni && this.tabellaDichiarazioni.loadPage();
      this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, searchTerm.trim(), this.props.annoSelezionato, true);
    });
  };

  setTabSelezionato = (index) => {
    const { tabSelezionato } = this.state;
    const { ufficioSelezionato } = this.props;

    const fromStorageKey = this.getStorageKey(ufficioSelezionato.CodiceUfficio, tabSelezionato);
    const toStorageKey = this.getStorageKey(ufficioSelezionato.CodiceUfficio, index);

    const { sortProperty, sortOrder } = JSON.parse(window.sessionStorage.getItem(fromStorageKey) || '{}');
    const toItem = {
      filtri: {},
      pageSize: 10,
      currentPage: 0,
      ...JSON.parse(window.sessionStorage.getItem(toStorageKey) || '{}'),
      sortProperty,
      sortOrder,
    };

    window.sessionStorage.setItem(toStorageKey, JSON.stringify(toItem));

    this.setState({ tabSelezionato: index });
  };

  // #region Azioni massive

  azioneMassivaStampaDiProva = () => {
    azioniMassive.stampaDiProva(this.state.selezionati);
  };

  azioneMassivaStampaUfficiale = () => {
    azioniMassive.stampaUfficiale(this.state.selezionati);
  };

  azioneMassivaStampeVarie = () => {
    azioniMassive.stampeVarie(this.state.selezionati);
  };

  azioneMassivaDaInviare = () => {
    azioniMassive.statoDaInviare(this.state.selezionati, this.props.annoSelezionato);
  };

  azioneMassivaCompleta = () => {
    azioniMassive.statoCompleta(this.state.selezionati, this.props.annoSelezionato);
  };

  azioneMassivaAnnulla = () => {
    azioniMassive.statoAnnullata(this.state.selezionati, this.props.annoSelezionato);
  };

  azioneMassivaInLavorazione = () => {
    azioniMassive.statoInLavorazione(this.state.selezionati, this.props.annoSelezionato);
  };

  tabulatoDebitiCrediti = () => {
    const { selezionati, selezionaTutte } = this.state;
    const { utente, ufficioSelezionato, annoSelezionato } = this.props;

    azioniMassive.tabulatoDebitiCrediti(
      selezionati,
      selezionaTutte,
      utente.IdentificativoUtente,
      ufficioSelezionato.CodiceUfficio,
      annoSelezionato,
      this.tabellaDichiarazioni.urlCorrente().replace('/SetteTrenta/CercaSetteTrenta?', ''),
    );
  };

  tabulatoOneriAnnoPrecedente = () => {
    const { selezionati, selezionaTutte } = this.state;
    const { utente, ufficioSelezionato, annoSelezionato } = this.props;

    // Non ci sono limiti nel numero di elementi per il
    // tabulato oneri anno precedente
    azioniMassive.tabulatoOneriAnnoPrecedente(
      selezionati,
      selezionaTutte,
      utente.IdentificativoUtente,
      ufficioSelezionato.CodiceUfficio,
      annoSelezionato,
      this.tabellaDichiarazioni.urlCorrente().replace('/SetteTrenta/CercaSetteTrenta?', ''),
    );
  };

  // tabulato dettaglio prospetto di liquidazione quadro A
  tabulatoDettaglioProspettoLiquidazioneQuadroA = () => {
    const { selezionati, selezionaTutte } = this.state;
    const { utente, ufficioSelezionato, annoSelezionato } = this.props;

    azioniMassive.tabulatoDettaglioProspettoLiquidazioneQuadroA(
      selezionati,
      selezionaTutte,
      utente.IdentificativoUtente,
      ufficioSelezionato.CodiceUfficio,
      annoSelezionato,
      this.tabellaDichiarazioni.urlCorrente().replace('/SetteTrenta/CercaSetteTrenta?', ''),
    );
  };

  // tabulato dettaglio prospetto di liquidazione quadro B
  tabulatoDettaglioProspettoLiquidazioneQuadroB = () => {
    const { selezionati, selezionaTutte } = this.state;
    const { utente, ufficioSelezionato, annoSelezionato } = this.props;

    azioniMassive.tabulatoDettaglioProspettoLiquidazioneQuadroB(
      selezionati,
      selezionaTutte,
      utente.IdentificativoUtente,
      ufficioSelezionato.CodiceUfficio,
      annoSelezionato,
      this.tabellaDichiarazioni.urlCorrente().replace('/SetteTrenta/CercaSetteTrenta?', ''),
    );
  };

  // #endregion

  apriCreazioneOrdinaria = () => {
    this.setState({
      mostraModaleCreazione: true,
      tipoDichiarazioneCreazione: ModaleCreazione.TipoDichiarazione.ORDINARIA,
    });
  };

  apriModaleStampa = (anno) => {
    if (anno >= 2020) {
      this.setState({ mostraModaleStampa2: true });
    } else {
      this.setState({ mostraModaleStampa: true, messaggioErroreStampa: null });
    }
  };

  esportaExcel = () => {
    window.open(this.tabellaDichiarazioni.dataTable.urlCorrente().replace('/SetteTrenta/CercaSetteTrenta', '/SetteTrenta/EsportaExcel'), 'target=_blank');
  };

  chiudiModaleStampa = () => {
    this.setState({ mostraModaleStampa: false, mostraModaleStampa2: false, isLoadingModaleStampa: false });
  };

  apriCreazioneIntegrativa = () => {
    this.setState({ mostraModaleCreazione: true, tipoDichiarazioneCreazione: ModaleCreazione.TipoDichiarazione.INTEGRATIVA });
  };

  chiudiModaleCreazione = () => {
    this.setState({ mostraModaleCreazione: false, tipoDichiarazioneCreazione: ModaleCreazione.TipoDichiarazione.NON_SELEZIONATO, messaggioErroreCreazione: null });
  };

  stampaTerminata = (evt) => {
    const { stampaInCorso } = this.state;
    if (stampaInCorso && evt.DichiarazioniProcessate === evt.DichiarazioniTotali) {
      this.setState({ stampaInCorso: false, selezionati: [], selezionaTutte: false });
      this.tabellaDichiarazioni && this.tabellaDichiarazioni.loadPage();
    }
    // this.ricaricaTabella(); provo a togliere per evitare un gran numero di refresh inutili e non necessari
  };

  annullaSelezione = () => {
    this.setState({ selezionati: [], selezionaTutte: false });
    this.tabellaDichiarazioni.pulisciSelezione();
  };

  apriImportazioneXmlAnnoCorrente = () => {
    this.setState({ mostraModaleImportazione: true, tipoImportazione: ModaleImportazione.TipoImportazione.Corrente, annoImportazione: 2021 });
  };

  apriImportazioneXmlAnnoCorrenteRettificativi2019 = () => {
    this.setState({ mostraModaleImportazione: true, tipoImportazione: ModaleImportazione.TipoImportazione.Corrente, annoImportazione: 2019 });
  };

  apriImportazioneXmlAnnoCorrenteRettificativi = () => {
    this.setState({ mostraModaleImportazione: true, tipoImportazione: ModaleImportazione.TipoImportazione.Corrente, annoImportazione: 2020 });
  };

  apriImportazioneXmlAnnoPrecedente = () => {
    this.setState({ mostraModaleImportazione: true, tipoImportazione: ModaleImportazione.TipoImportazione.Precedente, annoImportazione: 2020 });
  };

  apriImportazioneRedditiPFAnnoPrecedente = () => {
    this.setState({ mostraModaleImportazioneRedditiPF: true, tipoImportazione: ModaleImportazione.TipoImportazione.Precedente, annoImportazione: 2020 });
  };

  apriImportazioneCU = () => {
    this.setState({ urlFileUpload: `/SetteTrenta/ImportazioneCU?studio=${this.props.ufficioSelezionato.CodiceUfficio}&anno=${this.props.annoSelezionato}`, typeFileUpload: ['.xml'], mostraModaleUpload: true });
  };

  apriImportazionePdf = () => {
    this.setState({ mostraModaleImportazionePdf: true });
  };

  chiudiModaleImportazionePdf = () => {
    this.setState({ mostraModaleImportazionePdf: false });
  };

  chiudiModaleImportazione = () => {
    this.setState({ mostraModaleImportazione: false, tipoImportazione: ModaleImportazione.TipoImportazione.NonSelezionato, messaggioErroreImportazione: null });
  };

  chiudiModaleImportazioneRedditiPF = () => {
    this.setState({ mostraModaleImportazioneRedditiPF: false, tipoImportazione: ModaleImportazione.TipoImportazione.NonSelezionato, messaggioErroreImportazione: null });
  };

  chiudiModaleUpload = () => {
    this.setState({ urlFileUpload: '', typeFileUpload: [], mostraModaleUpload: false });
  };

  impostaAnnoSelezionato = (data) => {
    if (data.Anno >= 2021) {
      window.location.hash = '/NewSetteTrenta/lista-dichiarazioni';
    }

    this.props.setAnnoSelezionato(data.Anno);
  };

  accediAudit = () => {
    window.open(`${window.config.AuditUrl}`, '_blank');
  };

  apriMonitorStampe = () => {
    window.location.hash = '/elaborazionimassive';
  };

  getStorageKey(codiceUfficio, tabSelezionato) {
    switch (tabSelezionato) {
      case 0: return `${codiceUfficio}tableTutte_730`;
      case 1: return `${codiceUfficio}tableLavorazione_730`;
      case 2: return `${codiceUfficio}tableDaInviare_730`;
      case 3: return `${codiceUfficio}tableTrasmesse_730`;
      case 4: return `${codiceUfficio}tableScartate_730`;
      default: return '';
    }
  }

  scaricaRicevuteAdE = (item = {}) => {
    const { ufficioSelezionato, annoSelezionato } = this.props;
    const {
      IdDichiarazione, CodiceFiscale, Cognome, Nome,
    } = item;
    creaStampa(
      `$filter=Stato eq ${StatoDichiarazione.TrasmessaAutomaticamente}`,
      IdDichiarazione ? [{
        id: IdDichiarazione, cf: CodiceFiscale, cognome: Cognome, nome: Nome,
      }] : null,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      1,
      false,
      ufficioSelezionato.CodiceUfficio,
      annoSelezionato,
      false,
    ).then((resp) => {
      if (!resp.Success) {
        SnackbarManager.notifyError(`Si è verificato un errore durante lo scaricamento ${IdDichiarazione ? 'della ricevuta' : 'delle ricevute'} AdE`);
      } else {
        SnackbarManager.notifySuccess(`Scaricamento ${IdDichiarazione ? 'della ricevuta' : 'delle ricevute'} AdE avviato`);
      }
    })
      .catch(() => SnackbarManager.notifyError(`Si è verificato un errore durante lo scaricamento ${IdDichiarazione ? 'della ricevuta' : 'delle ricevute'} AdE`));
  };

  render() {
    const {
      ufficioSelezionato,
      utente,
      anniRegistrati,
      annoSelezionato,
      servizioAttivo,
      accessoNonConsentito,
    } = this.props;
    const {
      messaggioErroreCreazione,
      messaggioErroreStampa,
      messaggioErroreImportazione,
      mostraModaleCreazione,
      mostraModaleImportazione,
      mostraModaleImportazioneRedditiPF,
      annoImportazione,
      mostraModaleUpload,
      mostraModaleStampa,
      mostraModaleStampa2,
      mostraModaleNotificaScarto,
      mostraModaleScadenze,
      mostraUltimaScadenza,
      mostraTermineUltimo,
      dichiarazioniScartate,
      tabSelezionato,
      selezionati,
      searchTerm,
      tipoDichiarazioneCreazione,
      isLoadingModaleCreazione,
      isLoadingModaleStampa,
      tipoImportazione,
      isLoadingModaleImportazione,
      isLoadingModaleUpload,
      stampaInCorso,
      nTotali,
      nDaInviare,
      nLavorazione,
      nScartate,
      nTrasmesse,
      nRicevuteAdE,
      urlFileUpload,
      typeFileUpload,
      mostraModaleImportazionePdf,
      puoImportareXMLAnnoCorrente,
      selezionaTutte,
      elementi,
      totaleElementi,
      impostazioni,
      nonVisualizzarePiuNotificaUltimaScadenza,
      nonVisualizzarePiuNotificaTermineUltimo,
      delegatoCentrale,
    } = this.state;

    const badgeConteggio = (count) => (count != 0 ? <Badge info>{count}</Badge> : null);
    const badgeConteggioScartate = (count) => (count != 0 ? <Badge alarm>{count}</Badge> : null);

    const dichiarazioniNonStampate = (items) => {
      let nr = 0;
      items.forEach((x) => {
        if (x.DatiAddizionali && x.DatiAddizionali.StampaUfficialeEffettuata == 'False') {
          nr++;
        }
      });
      return nr;
    };

    const dichiarazioniStampate = (items) => {
      let nr = 0;
      items.forEach((x) => {
        if (x.DatiAddizionali && x.DatiAddizionali.StampaUfficialeEffettuata == 'True') {
          nr++;
        }
      });
      return nr;
    };

    const stampaDisabled = (this.tabellaDichiarazioni && this.tabellaDichiarazioni.getSelezionati().length == 0) || stampaInCorso === true;

    const commonElasticTableProps = {
      anniRegistrati,
      onSelezionati: (i) => this.setState({ selezionati: i.filter((z) => annoSelezionato > 2019 || z.Stato != 6), selezionaTutte: false }),
      onPageLoad: (elementi, totaleElementi) => this.setState({ elementi, totaleElementi }),
      row: RigaDichiarazione,
      searchTerm,
      scaricaRicevutaAdE: this.scaricaRicevuteAdE,
      ufficio: ufficioSelezionato.CodiceUfficio,
      impostazioni: impostazioni[annoSelezionato],
    };

    const dataAttuale = Date.now();
    let prossimaScadenza = Scadenze730.NonSelezionato;

    // al primo render 'delegatoCentrale' è nullo e quindi evito di renderizzare il messaggio, poi diventa true/false
    if (delegatoCentrale != null) {
      const elencoScadenze = (delegatoCentrale ? window.config.scadenze730Centralizzati : window.config.scadenze730).split(',').slice();
      let indexScadenze = 0;
      for (indexScadenze = 0; indexScadenze < elencoScadenze.length; indexScadenze++) {
        const scadenza = elencoScadenze[indexScadenze];
        // console.log(dataAttuale, Date.parse(new Date(scadenza).toUTCString()), dataAttuale < Date.parse(new Date(scadenza).toUTCString()));
        if (dataAttuale < Date.parse(new Date(scadenza).toUTCString())) {
          prossimaScadenza = indexScadenze;
          break;
        }
      }
    }

    const pannelloScadenziario = (
      <div>
        {prossimaScadenza == Scadenze730.Agosto23
          && (
            <Panel info className="panelScadenza">
              <span>Le dichiarazioni con precompilato evaso
                <InfoTooltip>
                  <p>Saranno inviate all'Agenzia delle Entrate solo le dichiarazioni con richiesta del precompilato in stato "evasa". <br /><br />Puoi verificare lo stato delle richieste del precompilato dal servizio "Richieste Enti".</p>
                </InfoTooltip> trasmesse a CGN entro il <b>23/08 alle ore 24:00</b> saranno inviate all'Agenzia delle Entrate
                <InfoTooltip>
                  <p>La gestione operativa dell'invio all'Agenzia delle Entrate richiederà qualche giorno.</p>
                </InfoTooltip> per consentire i conguagli entro la prima mensilità utile. <a className="buttonComeLink" onClick={() => this.setState({ mostraModaleScadenze: true })}>Visualizza le scadenze del 730</a>
              </span>
            </Panel>
          )}
        {prossimaScadenza == Scadenze730.Agosto31
          && (
            <Panel info className="panelScadenza">
              <span>Le dichiarazioni trasmesse a CGN entro il <b>31/08 alle ore 24:00</b> saranno inviate all'Agenzia delle Entrate
                <InfoTooltip>
                  <p>La gestione operativa dell'invio all'Agenzia delle Entrate richiederà qualche giorno.</p>
                </InfoTooltip> come previsto dalla normativa. <a className="buttonComeLink" onClick={() => this.setState({ mostraModaleScadenze: true })}>Visualizza le scadenze del 730</a>
              </span>
            </Panel>
          )}
        {prossimaScadenza == Scadenze730.Settembre22
          && (
            <Panel info className="panelScadenza">
              <span>Le dichiarazioni con precompilato evaso
                <InfoTooltip>
                  <p>Saranno inviate all'Agenzia delle Entrate solo le dichiarazioni con richiesta del precompilato in stato "evasa". <br /><br />Puoi verificare lo stato delle richieste del precompilato dal servizio "Richieste Enti".</p>
                </InfoTooltip> trasmesse a CGN entro il <b>22/09 alle ore 24:00</b> saranno inviate all'Agenzia delle Entrate
                <InfoTooltip>
                  <p>La gestione operativa dell'invio all'Agenzia delle Entrate richiederà qualche giorno.</p>
                </InfoTooltip> per consentire i conguagli entro la prima mensilità utile. <a className="buttonComeLink" onClick={() => this.setState({ mostraModaleScadenze: true })}>Visualizza le scadenze del 730</a>
              </span>
            </Panel>
          )}
        {!delegatoCentrale && prossimaScadenza == Scadenze730.UltimaScadenza
          && (
            <Panel alert className="panelScadenza">
              <span>Hai tempo fino al <b>28/09 alle ore 23:00</b>
                <InfoTooltip>
                  <p>Ti chiediamo di trasmettere tutte le dichiarazioni a CGN con 2 giorni di anticipo rispetto alla chiusura normativa della Campagna Fiscale (30/09) per permetterci la gestione operativa dell'invio all'Agenzia della Entrate.</p>
                </InfoTooltip> per trasmettere le dichiarazioni a CGN al fine di poterle inviare all'Agenzia delle Entrate entro il <b>termine della campagna fiscale</b>.
              </span>
            </Panel>
          )}
        {delegatoCentrale && prossimaScadenza == Scadenze730.UltimaScadenza
          && (
            <Panel alert className="panelScadenza">
              <span>Hai tempo fino al <b>27/09 alle ore 23:00</b>
                <InfoTooltip>
                  <p>Ti chiediamo di trasmettere tutte le dichiarazioni a CGN con 5 giorni di anticipo rispetto alla chiusura normativa della Campagna Fiscale (30/09) per permetterci la verifica e la gestione delle dichiarazioni.</p>
                </InfoTooltip> per trasmettere le dichiarazioni a CGN al fine di poterle inviare all'Agenzia delle Entrate entro il <b>termine della campagna fiscale</b>.
              </span>
            </Panel>
          )}
        {delegatoCentrale && prossimaScadenza == Scadenze730.TermineUltimo
          && (
            <Panel alert className="panelScadenza">
              <span>
                Hai tempo fino alle <b>16.00 di oggi, 28/09</b> per correggere ed integrare le eventuali dichiarazioni con status "Scartata Audit" nella sezione "Scartate".
              </span>
            </Panel>
          )}
      </div>
    );

    const totaleSelezionabili = elementi.filter((z) => annoSelezionato > 2019 || z.Stato != 6).length;
    const totaleElementiSelezionabili = totaleElementi; // Math.min(totaleElementi, window.config.maxDichiarazioniStampabili);
    const totaleSelezionati = selezionaTutte ? totaleElementiSelezionabili : selezionati.length;

    const pannelloSelezionati = totaleSelezionati > 0 && (
      <Panel info>
        <span style={{ marginTop: '10px' }}>Hai selezionato <b>{totaleSelezionati}</b> {totaleSelezionati !== 1 ? 'dichiarazioni' : 'dichiarazione'}.</span>
        {totaleSelezionati === totaleElementiSelezionabili && elementi.length < totaleElementiSelezionabili && <Button primary text onClick={() => this.annullaSelezione()}>Annulla selezione</Button>}
        {annoSelezionato > 2019 && totaleSelezionati === totaleSelezionabili && totaleSelezionati < totaleElementiSelezionabili
          && (
            <Button primary text onClick={() => this.setState({ selezionaTutte: true })}>
              {totaleElementi === totaleElementiSelezionabili ? <span>Seleziona tutte le <b>{totaleElementi}</b> dichiarazioni</span>
                : <span>Seleziona <b>{totaleElementiSelezionabili}</b> dichiarazioni</span>}
              {/* da rivedere */}
            </Button>
          )}
      </Panel>
    );

    let anniRegistratiFiltrato = anniRegistrati;
    if (window.config.ufficiAbilitatiPreRilascio != '*') {
      // se la chiave contiene dei valori significa che voglio abilitare l'anno solo per alcuni uffici
      let vediSeAbilitare = false;
      window.config.ufficiAbilitatiPreRilascio.split(',').forEach((element) => {
        if (ufficioSelezionato.CodiceUfficio == element) {
          vediSeAbilitare = true;
        }
      });
      if (vediSeAbilitare == false) {
        anniRegistratiFiltrato = anniRegistrati.filter((x) => x.Anno != 2020);
        if (annoSelezionato == 2020) {
          this.props.setAnnoSelezionato(2019);
        }
      }
    }

    return (
      <PageWrapper
        helmetTitle="730"
        pageTitle={(
          <div className="w-300">
            <div className="w-140 floatLeft mr-8">
              <span>730 </span>
            </div>
            <div className="floatLeft">
              <Dropdown title={annoSelezionato} toggleComponent={<div className="SelettoreAnno"> {annoSelezionato} <span className="dropdown__caret--open" /></div>}>
                {
                  anniRegistratiFiltrato.map((x) => (
                    <Dropdown.Item key={x.Anno} onClick={() => this.impostaAnnoSelezionato(x)}>{x.Anno}</Dropdown.Item>))
                }
              </Dropdown>
            </div>
          </div>
        )}
        pageActions={(
          <ButtonGroup>
            <NotificaPotenzialiIsee anno={annoSelezionato} ufficio={ufficioSelezionato.CodiceUfficio} />
            <Button
              floating
              flat
              tooltip="Monitor Audit"
              onClick={() => this.accediAudit()}
            >
              <AuditIcon style={({ width: '19px', height: '19px' })} />
            </Button>

            {servizioAttivo && annoSelezionato == 2019 && (
              <Button floating onClick={this.esportaExcel} tooltip="Esporta in Excel">
                <ExcelIcon style={({ width: '36px', height: '36px' })} />
              </Button>
            )}

            {servizioAttivo && annoSelezionato == 2020 && (
              <Dropdown
                right
                toggleComponent={(
                  <Button floating tooltip="Tabulati">
                    <ExcelIcon style={({ width: '36px', height: '36px' })} />
                  </Button>
                )}
              >
                <Dropdown.Item onClick={() => this.esportaExcel()}> {/* ...azioniMassive.valutaAzioneMassivaCompleta(this.tabellaDichiarazioni.getSelezionati()) }> */}
                  Esporta tutte le<br /> dichiarazioni
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => this.tabulatoDebitiCrediti()}
                  {...azioniMassive.valutaAzioneMassivaTabulati(stampaDisabled)}
                >
                  Tabulato debiti/crediti
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => this.tabulatoOneriAnnoPrecedente()}
                  {...azioniMassive.valutaAzioneMassivaTabulati(stampaDisabled)}
                >
                  Tabulato oneri anno<br /> precedente
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => this.tabulatoDettaglioProspettoLiquidazioneQuadroA()}
                  {...azioniMassive.valutaAzioneMassivaTabulati(stampaDisabled)}
                >
                  Tabulato calcoli quadro A
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => this.tabulatoDettaglioProspettoLiquidazioneQuadroB()}
                  {...azioniMassive.valutaAzioneMassivaTabulati(stampaDisabled)}
                >
                  Tabulato calcoli quadro B
                </Dropdown.Item>

              </Dropdown>
            )}
          </ButtonGroup>
        )}
      >
        <Grid fluid className="pl-0 pr-0">
          <Grid.Row>
            <Grid.Col md="12">
              <Card
                title={
                  <span>Lista dichiarazioni</span>
                }

                multipleActions={(
                  <ButtonGroup>
                    {
                      servizioAttivo == true
                      && (
                        <Dropdown
                          right
                          toggleComponent={
                            (this.tabellaDichiarazioni && this.tabellaDichiarazioni.getSelezionati().length > 0)
                              ? <Button floating selected tooltip="Crea Dichiarazione"><PlusIcon /></Button>
                              : <Button floating primary tooltip="Crea Dichiarazione"><PlusIcon /></Button>
                          }
                        >
                          <Dropdown.Item onClick={this.apriCreazioneOrdinaria}>Nuova ordinaria</Dropdown.Item>
                          {impostazioni[annoSelezionato]
                            && impostazioni[annoSelezionato].CampagnaIntegrativiAperta
                            && <Dropdown.Item onClick={this.apriCreazioneIntegrativa}>Nuova integrativa</Dropdown.Item>}
                        </Dropdown>
                      )
                    }
                    <Dropdown
                      right
                      toggleComponent={
                        (this.tabellaDichiarazioni && this.tabellaDichiarazioni.getSelezionati().length > 0)
                          ? <Button floating primary tooltip="Stampa"><PrinterIcon /></Button>
                          : <Button floating selected tooltip="Stampa"><PrinterIcon /></Button>
                      }
                    >
                      <Dropdown.Item
                        onClick={() => this.apriModaleStampa(annoSelezionato)}
                        {...azioniMassive.valutaAzioneMassivaStampa(stampaDisabled)}
                      >Stampa dichiarazioni<br />selezionate
                      </Dropdown.Item>
                      {annoSelezionato > 2019
                        && (
                          <Dropdown.Item
                            onClick={() => this.apriMonitorStampe()}
                            showInfo
                            infoPosition="right"
                            infoContent="I file relativi alle stampe generate verranno mantenuti a disposizione per sette giorni"
                          >Monitora Stampe
                          </Dropdown.Item>
                        )}
                    </Dropdown>
                    {
                      servizioAttivo == true
                      && annoSelezionato == 2019
                      && ufficioSelezionato.CodiceUfficio == '00002'
                      && (
                        <Dropdown right toggleComponent={<Button floating selected tooltip="Importa"><ImportIcon /></Button>}>
                          <Dropdown.Item onClick={this.apriImportazioneXmlAnnoCorrenteRettificativi2019}>Uso interno: importa XML 730/2019 per rettificativi</Dropdown.Item>
                        </Dropdown>
                      )
                    }
                    {
                      servizioAttivo == true
                      && annoSelezionato == 2020
                      && ufficioSelezionato.CodiceUfficio == '00002'
                      && (
                        <Dropdown right toggleComponent={<Button floating selected tooltip="Importa"><ImportIcon /></Button>}>
                          {puoImportareXMLAnnoCorrente && <Dropdown.Item onClick={this.apriImportazioneXmlAnnoCorrenteRettificativi}>Uso interno: importa XML 730/2020 per rettificativi</Dropdown.Item>}
                        </Dropdown>
                      )
                    }
                    {/*
                      servizioAttivo == true
                      && annoSelezionato == 2020
                      && (
                        <Dropdown right toggleComponent={<Button floating selected tooltip="Importa"><ImportIcon /></Button>}>
                          <Dropdown.Item onClick={this.apriImportazioneCU}>Importa CU {annoSelezionato}</Dropdown.Item>
                          <Dropdown.Item onClick={this.apriImportazioneXmlAnnoPrecedente}>Importa XML 730/2020</Dropdown.Item>
                          {puoImportareXMLAnnoCorrente && <Dropdown.Item onClick={this.apriImportazioneXmlAnnoCorrente}>Importa XML 730/2021</Dropdown.Item>}
                          {window.datiUtente.ImportazionePdfAttivata && <Dropdown.Item onClick={this.apriImportazionePdf}>Importa PDF 730/2020</Dropdown.Item>}
                          <Dropdown.Item onClick={this.apriImportazioneRedditiPFAnnoPrecedente}>Importa RedditiPF/2020</Dropdown.Item>
                        </Dropdown>
                      )
                      */
                    }
                    {
                      servizioAttivo == true && this.tabellaDichiarazioni && this.tabellaDichiarazioni.getSelezionati().length > 0
                      && (
                        <Dropdown right toggleComponent={<Button floating selected><MoreIcon /></Button>}>
                          {(tabSelezionato == 0 || tabSelezionato == 1)
                            && (
                              <Dropdown.Item onClick={this.azioneMassivaCompleta} {...azioniMassive.valutaAzioneMassivaCompleta(this.tabellaDichiarazioni.getSelezionati(), selezionaTutte)}>
                                Imposta come "Completa"
                              </Dropdown.Item>
                            )}
                          {(tabSelezionato == 0 || tabSelezionato == 2)
                            && (
                              <Dropdown.Item onClick={this.azioneMassivaDaInviare} {...azioniMassive.valutaAzioneMassivaDaInviare(this.tabellaDichiarazioni.getSelezionati(), selezionaTutte)}>
                                Imposta come "Trasmessa CGN"
                              </Dropdown.Item>
                            )}
                          {(tabSelezionato == 0 || tabSelezionato == 2 || tabSelezionato == 4)
                            && (
                              <Dropdown.Item onClick={this.azioneMassivaInLavorazione} {...azioniMassive.valutaAzioneMassivaInLavorazione(this.tabellaDichiarazioni.getSelezionati(), selezionaTutte)}>
                                Imposta come "In Lavorazione"
                              </Dropdown.Item>
                            )}
                          {(tabSelezionato == 0 || tabSelezionato == 3)
                            && (
                              <Dropdown.Item onClick={this.azioneMassivaAnnulla} {...azioniMassive.valutaAzioneMassivaAnnulla(this.tabellaDichiarazioni.getSelezionati(), selezionaTutte)}>
                                Imposta come "Annullata"
                              </Dropdown.Item>
                            )}
                          {false
                            && (
                              <Dropdown.Item
                                onClick={this.scaricaRicevuteAdE}
                                disabled={nRicevuteAdE === 0}
                                infoContent={nRicevuteAdE > 0 ? 'Scarica le ricevute dell\'Agenzia delle Entrate di tutte le dichiarazioni in status "Ricevuta AdE"' : 'Non è presente nessuna dichiarazione "Ricevuta da AdE"'}
                                showInfo
                              >
                                Scarica tutte le ricevute AdE
                              </Dropdown.Item>
                            )}
                        </Dropdown>
                      )
                    }
                  </ButtonGroup>
                )}
              >
                {annoSelezionato == 2020 && pannelloScadenziario}
                <Grid.Row>
                  <Grid.Col md="5">
                    {!servizioAttivo && !accessoNonConsentito && <Panel error>Il servizio non è attivo. L'accesso è permesso solo in consultazione</Panel>}
                    <InputRicerca onClickCerca={this.onClickCerca} ref={(r) => { this.inputRicerca = r; }} />
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col md="12">
                    <Tabs initialIndex={INITIAL_TAB_INDEX} onSelect={this.setTabSelezionato} index={tabSelezionato} store={`${ufficioSelezionato.CodiceUfficio}tabs_730`}>
                      <Tabs.Tab title={<span>Tutte {badgeConteggio(nTotali)}</span>}>
                        {pannelloSelezionati}
                        <ElasticTable
                          {...commonElasticTableProps}
                          ref={(r) => { this.tabellaDichiarazioni = r; }}
                          tabNr={0}
                          statoRicerca={ElasticTable.StatiRicercaSetteTrenta.TUTTE}
                          annoSelezionato={annoSelezionato}
                          store={this.getStorageKey(ufficioSelezionato.CodiceUfficio, 0)}
                        />
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>In lavorazione {badgeConteggio(nLavorazione)}</span>}>
                        {pannelloSelezionati}
                        <ElasticTable
                          {...commonElasticTableProps}
                          ref={(r) => { this.tabellaDichiarazioni = r; }}
                          tabNr={1}
                          statoRicerca={ElasticTable.StatiRicercaSetteTrenta.IN_LAVORAZIONE}
                          annoSelezionato={annoSelezionato}
                          store={this.getStorageKey(ufficioSelezionato.CodiceUfficio, 1)}
                        />
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Da inviare {badgeConteggio(nDaInviare)}</span>}>
                        {pannelloSelezionati}
                        <ElasticTable
                          {...commonElasticTableProps}
                          ref={(r) => { this.tabellaDichiarazioni = r; }}
                          tabNr={2}
                          statoRicerca={ElasticTable.StatiRicercaSetteTrenta.DA_INVIARE}
                          annoSelezionato={annoSelezionato}
                          store={this.getStorageKey(ufficioSelezionato.CodiceUfficio, 2)}
                        />
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Trasmesse {badgeConteggio(nTrasmesse)}</span>}>
                        {pannelloSelezionati}
                        <ElasticTable
                          {...commonElasticTableProps}
                          ref={(r) => { this.tabellaDichiarazioni = r; }}
                          tabNr={3}
                          statoRicerca={ElasticTable.StatiRicercaSetteTrenta.TRASMESSE}
                          annoSelezionato={annoSelezionato}
                          store={this.getStorageKey(ufficioSelezionato.CodiceUfficio, 3)}
                        />
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Scartate {badgeConteggioScartate(nScartate)}</span>}>
                        {pannelloSelezionati}
                        <ElasticTable
                          {...commonElasticTableProps}
                          ref={(r) => { this.tabellaDichiarazioni = r; }}
                          tabNr={4}
                          statoRicerca={ElasticTable.StatiRicercaSetteTrenta.SCARTATE}
                          annoSelezionato={annoSelezionato}
                          store={this.getStorageKey(ufficioSelezionato.CodiceUfficio, 4)}
                        />
                      </Tabs.Tab>
                    </Tabs>
                  </Grid.Col>
                </Grid.Row>
              </Card>
            </Grid.Col>
          </Grid.Row>

          {mostraModaleCreazione
            && (
              <ModaleCreazione
                showModal
                anniRegistrati={anniRegistrati}
                isLoading={isLoadingModaleCreazione}
                tipoDichiarazione={tipoDichiarazioneCreazione}
                messaggioErrore={messaggioErroreCreazione}
                onAnnulla={this.chiudiModaleCreazione}
                onCreaNuova={this.creaNuovaDichiarazione}
                onRipristinaEliminata={this.ripristinaEliminata}
                ufficioSelezionato={ufficioSelezionato.CodiceUfficio}
                annoSelezionato={annoSelezionato}
                impostazioni={impostazioni[annoSelezionato]}
              />
            )}

          <ModaleStampa
            showModal={mostraModaleStampa}
            isLoadingModale={isLoadingModaleStampa}
            onAnnulla={this.chiudiModaleStampa}
            stampaProva={tabSelezionato == 1 || tabSelezionato == 2 || tabSelezionato == 4}
            userId={utente.IdentificativoUtente}
            onStampa={this.stampaDichiarazioniOld}
            messaggioErrore={messaggioErroreStampa}
            tabTutte={tabSelezionato == 0}
            nrDichiarazioniSelezionate={selezionati.length}
            nrDichiarazioniSelezionateNonStampate={dichiarazioniNonStampate(selezionati)}
            nrDichiarazioniSelezionateStampate={dichiarazioniStampate(selezionati)}
            annoSelezionato={annoSelezionato}
          />

          <ModaleStampa2
            showModal={mostraModaleStampa2}
            isLoadingModale={isLoadingModaleStampa}
            onAnnulla={this.chiudiModaleStampa}
            stampaProva={tabSelezionato == 1 || tabSelezionato == 2 || tabSelezionato == 4}
            userId={utente.IdentificativoUtente}
            onStampa={this.stampaDichiarazioni}
            messaggioErrore={messaggioErroreStampa}
            nrDichiarazioniSelezionate={selezionati.length}
            nrDichiarazioniSelezionateStampate={dichiarazioniStampate(selezionati)}
            annoSelezionato={annoSelezionato}
            ufficioSelezionato={ufficioSelezionato}
            selezionatiDaAnnoPrecedente={selezionati.some((z) => z.Stato == 6)}
            totaleSelezionati={totaleSelezionati}
          />

          {mostraModaleImportazione
            && (
              <ModaleImportazione
                showModal
                isLoading={isLoadingModaleImportazione}
                tipoImportazione={tipoImportazione}
                messaggioErrore={messaggioErroreImportazione}
                onAnnulla={this.chiudiModaleImportazione}
                onCreaNuova={this.creaDaImportazione}
                onRipristinaEliminata={this.ripristinaEliminata}
                ufficioSelezionato={ufficioSelezionato.CodiceUfficio}
                annoSelezionato={annoImportazione}
              />
            )}

          {mostraModaleImportazioneRedditiPF
            && (
              <ModaleImportazioneRedditiPF
                showModal
                isLoading={isLoadingModaleImportazione}
                tipoImportazione={tipoImportazione}
                messaggioErrore={messaggioErroreImportazione}
                onAnnulla={this.chiudiModaleImportazioneRedditiPF}
                onCreaNuova={this.creaDaImportazioneRedditiPF}
                onRipristinaEliminata={this.ripristinaEliminataRedditiPF}
                ufficioSelezionato={ufficioSelezionato.CodiceUfficio}
                annoSelezionato={annoImportazione}
              />
            )}

          {mostraModaleUpload
            && (
              <ModaleUploadFile
                showModal
                urlUpload={urlFileUpload}
                fileType={typeFileUpload}
                isLoading={isLoadingModaleUpload}
                onAnnulla={this.chiudiModaleUpload}
              />
            )}

          {mostraModaleImportazionePdf && (
            <ModaleImportazionePdf
              showModal
              onAnnulla={this.chiudiModaleImportazionePdf}
              ufficioSelezionato={ufficioSelezionato.CodiceUfficio}
            />
          )}

          {
            mostraModaleNotificaScarto
            && (
              <ModaleNotificaScarto
                url730={anniRegistrati.filter((x) => x.Anno == annoSelezionato)[0].Url730}
                dichiarazioniScartate={dichiarazioniScartate}
                onClose={() => this.setState({ mostraModaleNotificaScarto: false, tabSelezionato: 4 })}
              />
            )
          }

          {
            mostraModaleScadenze && (
              <ModaleScadenze
                delegatoCentrale={delegatoCentrale}
                prossimaScadenza={prossimaScadenza}
                onClose={() => this.setState({ mostraModaleScadenze: false })}
              />
            )
          }

          {
            annoSelezionato == 2020 && prossimaScadenza == Scadenze730.UltimaScadenza && mostraUltimaScadenza == true && (
              <ModaleUltimaScadenza
                nonVisualizzarePiu={nonVisualizzarePiuNotificaUltimaScadenza}
                onNonVisualizzarePiu={this.onNonVisualizzarePiuNotificaUltimaScadenza}
                onClose={() => this.setState({ mostraUltimaScadenza: false })}
                delegatoCentrale={delegatoCentrale}
              />
            )
          }

          {
            annoSelezionato == 2020 && delegatoCentrale && prossimaScadenza == Scadenze730.TermineUltimo && mostraTermineUltimo == true && (
              <ModaleTermineUltimo
                nonVisualizzarePiu={nonVisualizzarePiuNotificaTermineUltimo}
                onNonVisualizzarePiu={this.onNonVisualizzarePiuNotificaTermineUltimo}
                onClose={() => this.setState({ mostraTermineUltimo: false })}
              />
            )
          }
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStoreToProps = (store) => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
  utente: store.utente.profilo,
  anniRegistrati: store.dichiarativi.anniRegistrati.data,
  annoSelezionato: store.dichiarativi.annoSelezionato,
});

const mapDispatchToProps = (dispatch) => ({
  setAnnoSelezionato: bindActionCreators(setAnnoSelezionato, dispatch),
  startLoadingApplication: bindActionCreators(startLoadingApplication, dispatch),
  stopLoadingApplication: bindActionCreators(stopLoadingApplication, dispatch),
});

Dichiarazioni.propTypes = {
  ufficioSelezionato: PropTypes.object,
  annoSelezionato: PropTypes.number.isRequired,
  utente: PropTypes.object,
  startLoadingApplication: PropTypes.func,
  stopLoadingApplication: PropTypes.func,
  servizioAttivo: PropTypes.bool,
  accessoNonConsentito: PropTypes.bool,
};

export default checkServizio(Servizi['7OL'])(connect(mapStoreToProps, mapDispatchToProps)(Dichiarazioni));
